"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FetchRequester_1 = require("./FetchRequester");
var TelemetryForwarder = /** @class */ (function () {
    function TelemetryForwarder() {
        this.requester = new FetchRequester_1.FetchRequester(TelemetryForwarder.methodName);
    }
    TelemetryForwarder.prototype.send = function (reportEventUnauthenticatedParams) {
        this.requester.send(reportEventUnauthenticatedParams);
    };
    // This is the VizPortal API for forwarding telemetry info and calling the PUT Java API to send to BigQuery
    TelemetryForwarder.methodName = 'reportEventUnauthenticated';
    return TelemetryForwarder;
}());
exports.TelemetryForwarder = TelemetryForwarder;
//# sourceMappingURL=TelemetryForwarder.js.map